<!-- Main content area -->
<div>
  <div>
    <!-- breadcrumb -->
    @if (showBreadcrumb()) {
      <div class="flex flex-row">
        <div class="grow">
          <nx-pageTitle-box-topline
            [bcRootLvlLabel]="'Vorgänge'"
            [bcRootLvlPath]="'/issues'">
          </nx-pageTitle-box-topline>
        </div>
      </div>
    }

  <!-- main line -->
  <div class="labelLine flex flex-row basis-full">

    <!-- icon, title and tag -->
    <div class="flex flex-row grow mt-1">

      <!-- switch between subtitle and title form in edit mode -->
      @if (!isEditMode()) {
        <ng-container *ngTemplateOutlet="issueTitleTemplate"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="issueTitleFormTemplate"></ng-container>
      }

    </div>

    <!-- command buttons and menu -->
    <div class="flex flex-row justify-center ml-2">
      @if (!isEditMode()) {
        <nx-command-button
          class="mr-2"
          [style]="'dark'"
          [reloadable]="this"
          [hasCommands]="issue()"
          [commandInput]="updateCommandInput()">
        </nx-command-button>
      }
      <p-menu
        #menu
        (onShow)="onMenuShow()"
        (onHide)="onMenuHide()"
        [model]="menuItems()"
        [popup]="true"
        [appendTo]="'body'">
      </p-menu>
      <nx-default-button
        [ngClass]="{
          'nx-focus': menuVisible()
        }"
        [style]="'dark'"
        (click)="$any(menu).toggle($event)"
        [icon]="'icon-options'">
      </nx-default-button>
    </div>

  </div>

  <!-- page subtitle -->
  @if (!isEditMode()) {
    <div class="text-[14px] text-gray-500 mt-1 mb-2 flex flex-row items-center gap-2">
      <!-- tag -->
      <p-tag
        [value]="issue()?.issueStatus?.statusGroup?.binaryStatusLabel"
        [severity]="issue()?.issueStatus?.statusGroup?.isOpen ? 'success' : 'info'">
      </p-tag>
      <div class="mt-[2px]">
        {{issue()?.issueType?.name}} · Erstellt von <b><app-user-name [user]="issue()?.createdBy" /></b>&nbsp;<app-relative-time class="ml-1" [timestamp]="issue()?.createdDateTime" />
      </div>
    </div>
  }

  <!-- body -->
  <div class="bodyWrapper grid grid-cols-[minmax(67%,1fr)_minmax(13rem,18.125rem)] gap-8 mb-[1.25rem]">

    <!-- left side -->
    <div class="flex flex-col gap-4">

      <!-- switch between description and description form in edit mode -->
      @if (!isEditMode()) {
        <ng-container *ngTemplateOutlet="issueDescriptionTemplate"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="issueDescriptionFormTemplate"></ng-container>
      }

      @if (issue()?.issueType?.code !== 'generic') {
        <entity-link-list
          [sourceEntity]="issue()"
          [targetEntityType]="'Task'"
          [linkType]="'RELATED_TO'"
          [headline]="'Aufgaben'"
          [emptyMessage]="'Keine Aufgaben verbunden'">
            <ng-template nxTemplate="createButton">
              <nx-command-button
                [style]="'dark'"
                [reloadable]="this"
                [hasCommands]="issue()"
                [iconOnly]="true"
                [commandInput]="createTaskCommandInput()">
              </nx-command-button>
            </ng-template>
        </entity-link-list>
      } @else {
        <entity-link-list
          [sourceEntity]="issue()"
          [targetEntityType]="'Task'"
          [linkType]="'RELATED_TO'"
          [headline]="'Aufgaben'"
          [emptyMessage]="'Keine Aufgaben vorhanden'">
            <ng-template nxTemplate="createButton">
              <nx-command-button
                [style]="'dark'"
                [reloadable]="this"
                [hasCommands]="issue()"
                [iconOnly]="true"
                [commandInput]="createTaskCommandInput()">
              </nx-command-button>
            </ng-template>
        </entity-link-list>
      }

      @if (issue()?.issueType?.code === 'damage') {
        <app-file-gallery
          [ownerId]="issue()?.id"
          [ownerType]="'Issue'"
          [role]="'dmg-img'"
          [headline]="'Bilder'"
          [emptyMessage]="'Dateien hier ablegen oder klicken zum Hochladen (jpg, png, pdf, max. 10MB pro Datei)'">
        </app-file-gallery>

      }

      <app-file-list
        [ownerId]="issue()?.id"
        [ownerType]="'Issue'"
        [headline]="'Anhänge'"
        [emptyMessage]="'Dateien hier ablegen oder klicken zum Hochladen (max. 10MB pro Datei)'">
      </app-file-list>

      <!-- Zeiteinträge -->
      <app-timeEntry-list
        [ownerId]="issue()?.id"
        [ownerType]="'Issue'"
        [headline]="'Zeiterfassung'"
        [emptyMessage]="'Keine Zeiteinträge vorhanden'">
      </app-timeEntry-list>

      <!-- Activity stream -->
      <app-activity-stream
        #activityStreamRef
        [filterStorageKey]="'filter_state_issue_view'"
        [owner]="issue()">
      </app-activity-stream>

    </div>

    <!-- right side -->
    <div>
      <div class="flex flex-col">
        <div class="basis-full flex flex-col">

            <!-- change status widget -->
            <nx-change-issue-status-widget
              class="border-b border-gray mb-2"
              [issue]="issue()">
            </nx-change-issue-status-widget>

            <!-- due date time widget -->
            <nx-issue-dueDateTime-widget
              class="border-b border-gray mb-2"
              [issue]="issue()">
            </nx-issue-dueDateTime-widget>

            <!-- assignee widget -->
            <nx-assign-issue-widget
              class="border-b border-gray mb-2"
              [issue]="issue()">
            </nx-assign-issue-widget>

            <!-- labels widget -->
            <nx-label-widget
              class="border-b border-gray mb-2"
              [hasLabels]="issue()">
            </nx-label-widget>

            <nx-update-issue-location-widget
              class="border-b border-gray mb-2"
              [hasLocation]="issue()">
            </nx-update-issue-location-widget>

            <!-- issue type specific content -->
            @switch (issue()?.issueType?.code) {
              @case ('damage') {

                <!-- order link widget -->
                <nx-single-entity-link-widget
                  class="border-b border-gray"
                  [entity]="issue()"
                  [linkedEntityType]="'Order'"
                  [linkType]="'RELATED_TO'"
                  [placeholder]="'Auftrag auswählen'"
                  [label]="'Auftrag'">
                </nx-single-entity-link-widget>

                <!-- contact link widget -->
                <nx-single-entity-link-widget
                  class="border-b border-gray mb-2"
                  [entity]="issue()"
                  [linkedEntityType]="'Contact'"
                  [linkType]="'RELATED_TO'"
                  [placeholder]="'Kunde auswählen'"
                  [label]="'Kunde'">
                </nx-single-entity-link-widget>

                <!-- resource link widget -->
                <nx-single-entity-link-widget
                  class="border-b border-gray mb-2"
                  [entity]="issue()"
                  [linkedEntityType]="'Resource'"
                  [linkType]="'RELATED_TO'"
                  [placeholder]="'Ressource auswählen'"
                  [label]="'Ressource'">
                </nx-single-entity-link-widget>

              }

              @case ('check') {
                <!-- resource link widget -->
                <nx-single-entity-link-widget
                  class="border-b border-gray"
                  [entity]="issue()"
                  [linkedEntityType]="'Resource'"
                  [linkType]="'RELATED_TO'"
                  [placeholder]="'Ressource auswählen'"
                  [label]="'Ressource'">
                </nx-single-entity-link-widget>

                <!-- form widget -->
                <nx-select-form-widget
                  (reload)="reload()">
                </nx-select-form-widget>
              }

              @case ('generic') {

                <!-- order link widget -->
                <nx-single-entity-link-widget
                  class="border-b border-gray"
                  [entity]="issue()"
                  [linkedEntityType]="'Order'"
                  [linkType]="'RELATED_TO'"
                  [placeholder]="'Auftrag auswählen'"
                  [label]="'Auftrag'">
                </nx-single-entity-link-widget>

                <!-- contact link widget -->
                <nx-single-entity-link-widget
                  class="border-b border-gray"
                  [entity]="issue()"
                  [linkedEntityType]="'Contact'"
                  [linkType]="'RELATED_TO'"
                  [placeholder]="'Kunde auswählen'"
                  [label]="'Kunde'">
                </nx-single-entity-link-widget>

                <!-- resource link widget -->
                <nx-single-entity-link-widget
                  class="border-b border-gray"
                  [entity]="issue()"
                  [linkedEntityType]="'Resource'"
                  [linkType]="'RELATED_TO'"
                  [placeholder]="'Ressource auswählen'"
                  [label]="'Ressource'">
                </nx-single-entity-link-widget>

              }

              @case ('defect') {
                <!-- resource link widget -->
                <nx-single-entity-link-widget
                  class="border-b border-gray"
                  [entity]="issue()"
                  [linkedEntityType]="'Resource'"
                  [linkType]="'RELATED_TO'"
                  [placeholder]="'Ressource auswählen'"
                  [label]="'Ressource'">
                </nx-single-entity-link-widget>
              }
            }

        </div>
      </div>
    </div>
  </div>

  </div>
</div><!-- End main content area -->

<!-- issue title template -->
<ng-template #issueTitleTemplate>

    <div class="flex flex-row leading-[1.325rem] min-w-0">
      <div class="mr-1 w-[5px] shrink-0 self-stretch" [ngStyle]="{'background-color': issue()?.issueType?.color }"></div>
      <!-- Title row with icon, due date badge, and title -->
      <div class="font-medium text-[20px]">
        <div class="mr-1 float-left w-[18px] h-[18px] mt-[1px]">
          <app-issue-type-icon [issueType]="issue()?.issueType"></app-issue-type-icon>
        </div>
        {{issue()?.getPrefixedNumber() + ' · ' + issue()?.title}}
      </div>
    </div>
</ng-template>

<!-- issue title form template -->
<ng-template #issueTitleFormTemplate>
  <div
    class="form w-full mb-2"
    [formGroup]="issueFormGroup()!">
    <nx-edit-text-input
      formControlName="title"
      label="Titel">
    </nx-edit-text-input>
  </div>
</ng-template>

<!-- issue description template -->
<ng-template #issueDescriptionTemplate>
  <nx-default-box
    class="bg-white border border-gray rounded-md">
    <ng-template nxTemplate="body">
      @if (!isDescriptionEmpty(descriptionHtml())) {
        <div class="-mt-1 nx-view-tipTap" [innerHTML]="descriptionHtml()"></div>
      } @else {
        <span class="text-gray-500">Keine Beschreibung vorhanden.</span>
      }
    </ng-template>
  </nx-default-box>

</ng-template>

<!-- issue description form template -->
<ng-template #issueDescriptionFormTemplate>
  <div
    class="form"
   [formGroup]="issueFormGroup()!">

    <nx-edit-tipTap-input
      formControlName="description"
      [placeholder]="'Beschreibung eingeben...'"
      label="Beschreibung">
    </nx-edit-tipTap-input>

    <div class="mt-2">
      @if (isEditMode()) {
        <nx-default-button
          [style]="'dark'"
          [disabled]="!issueFormGroup()?.dirty || issueFormGroup()?.invalid"
          [label]="'Speichern'"
          (click)="saveChanges()">
        </nx-default-button>

        <nx-default-button
          class="ml-2"
          [style]="'dark'"
          [label]="'Abbrechen'"
          (click)="cancelChanges()">
        </nx-default-button>
      }
    </div>

  </div>
</ng-template>
